module.exports = __webpack_public_path__ + "img/shoplogo.1cc0916c.svg";